import { BASE_URL } from './Api/constants'

// Derive the Action Cable WebSocket URL from the HTTP API base URL.
// Can be overridden with REACT_APP_CABLE_URL env variable.
//
// e.g. https://some.ngrok-free.dev/api/v1  →  wss://some.ngrok-free.dev/cable
//      http://localhost:3001/api/v1         →  ws://localhost:3001/cable
export const getCableUrl = () => {
  if (process.env.REACT_APP_CABLE_URL) return process.env.REACT_APP_CABLE_URL

  return BASE_URL
    .replace(/^https/, 'wss')
    .replace(/^http(?!s)/, 'ws')
    .replace(/\/api\/v1.*$/, '/cable')
}
